/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gdpr_Audit_HintInputs */

const cs_gdpr_audit_hint = /** @type {(inputs: Gdpr_Audit_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Každé otevření, výpis, hledání, export i změna osobních údajů v této kanceláři. Záznamy nelze měnit ani mazat; po 5 letech se smažou.`)
};

const en_gdpr_audit_hint = /** @type {(inputs: Gdpr_Audit_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Every open, list, search, export and change of personal data in this office. Entries cannot be changed or deleted; they are removed after 5 years.`)
};

/**
* | output |
* | --- |
* | "Every open, list, search, export and change of personal data in this office. Entries cannot be changed or deleted; they are removed after 5 years." |
*
* @param {Gdpr_Audit_HintInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const gdpr_audit_hint = /** @type {((inputs?: Gdpr_Audit_HintInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gdpr_Audit_HintInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gdpr_audit_hint(inputs)
	return cs_gdpr_audit_hint(inputs)
});